/**
 * Key of the remembered Kult 18-01 export job: one job per publisher and year, so a job of another year never
 * offers its file for the year now shown (DB-876).
 *
 * @param publisherId the publisher
 * @param year the year as typed in the form
 * @returns the job key
 */
export var kult1801JobKey = function (publisherId, year) {
    return "kult-18-01.".concat(publisherId, ".").concat(year.trim());
};
